interface GuideNavProps {
  stepNumber: number;
  totalSteps: number;
  isReady: boolean;
  onPrev: () => void;
  onNext: () => void;
  onDone: () => void;
}

/**
 * Guide navigation bar — Previous / Next / Done buttons.
 * Next is disabled when the step has an isReady condition that isn't met.
 */
export function GuideNav({
  stepNumber,
  totalSteps,
  isReady,
  onPrev,
  onNext,
  onDone,
}: GuideNavProps) {
  const isFirst = stepNumber === 0;
  const isLast = stepNumber === totalSteps - 1;

  return (
    <div className="flex items-center justify-between">
      <button
        onClick={onPrev}
        disabled={isFirst}
        className="rounded-lg px-4 py-2 text-sm font-medium text-stone-600 transition-colors hover:bg-stone-100 disabled:opacity-30 disabled:hover:bg-transparent dark:text-stone-400 dark:hover:bg-stone-700/30"
      >
        Previous
      </button>

      {isLast ? (
        <button
          onClick={onDone}
          className="rounded-lg bg-cyan-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-cyan-700 dark:bg-cyan-700 dark:hover:bg-cyan-600"
        >
          Done
        </button>
      ) : (
        <button
          onClick={onNext}
          disabled={!isReady}
          className="rounded-lg bg-cyan-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-cyan-700 disabled:opacity-40 disabled:hover:bg-cyan-600 dark:bg-cyan-700 dark:hover:bg-cyan-600"
        >
          {isReady ? 'Next' : 'Waiting...'}
        </button>
      )}
    </div>
  );
}
